import { lazy } from 'react';

const loadContact = () => import('./Contacts');
const PageContacts = lazy(loadContact);

export default PageContacts;
